﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { IDisposable } from "../../interfaces/general";
import { LogService } from "../../services/logService";

@Component({
    module: FIQAssist,
    selector: "customerdropdownbox",
    template: `<dropdownbox read-only="$ctrl.readOnly"
                    value-submit="$ctrl.passValueSubmit(selected)"
                    ng-attr-mandatory="{{$ctrl.mandatory}}"
                    multiselecttext="'MULTIPLE_CUSTOMERS_SELECTED'"
                    multiselect="$ctrl.multiselect"
                    ng-visible = "$ctrl._items.length > 1"
                    hint="\'SELECT_CUSTOMER_PLEASE\'"
                    class="customerdropdownbox"
                    selected="$ctrl.customerKeys"
                    items="$ctrl._items"
                    iserror="$ctrl.iserror"
                    show-clear="{{$ctrl.showClear}}"
                    onselectionchanged="$ctrl.selectionchanged(selected)"></dropdownbox>`,
    require: {
        "application": "^application"
    }
})
class CustomerDropdownBox<T> implements IComponent {
    @Input() public readOnly: boolean;
    @Input() public iserror: boolean;
    public application: Application;
    private disposables: IDisposable[] = [];
    private _customerKeys: string[];

    constructor(
        @Inject() private logService: LogService
    ) {

    }

    private _mandatory;
    @Attribute() public get mandatory() {
        return this._mandatory;
    }
    public set mandatory(val: boolean | string) {
        this._mandatory = val === true || val === "true";
    }

    private _enableShowClear: boolean;
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear && this._enableShowClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }

    @Input() public get customerKeys(): string[] {
        return this._customerKeys;
    }

    public set customerKeys(keys: string[]) {
        this._customerKeys = keys;
    }

    @Input() multiselect: boolean;

    private _items: DropdownEntry<T>[];

    $onInit() {
        this.update(this.application.selectedCustomers);
        this.disposables.push(this.application.addOnAccountsChanged(s => this.update(s)));
    }

    $onDestroy() {
        this.disposables.forEach(d => {
            try { d() } catch (e) { this.logService.warning('CustomerDropdownBox', "Error while disposing", e); }
        });
    }

    private update(sel: { key: T, text: string }[]) {
        this._enableShowClear = true;
        this._items = sel.map((x) => <DropdownEntry<T>>{ key: x.key, text: x.text });
        if (this._items.length > 1) {
            this.customerKeys = [];
        } else if (this._items.length == 1) {
            this._enableShowClear = false;
        }
    }

    @Output() public onCustomerChanged: OutputArgs<{ customerKeys: any[] }>;
    public selectionchanged(selected: string[]) {
        this.customerKeys = selected;
        this.onCustomerChanged({ customerKeys: this.customerKeys });
    }
    @Output() public valueSubmit: OutputArgs<{ customerKeys: any[] }>;
    public passValueSubmit(selected: any[]) {
        this.customerKeys = selected;
        if (this.valueSubmit) this.valueSubmit({ customerKeys: this.customerKeys });
    }
}
